// extracted by mini-css-extract-plugin
export default {"tree":"Parts_tree__6YNHD","part":"Parts_part__YBZ4D"};